
import momentTimezone from "moment-timezone"
export default {
    methods: {
        returnDateFormat(date, format='YYYY-MM-DD') {
            if(!date) {
                return '';
            }
            return this.$moment(date).tz('Asia/Seoul').format(format)
        },
        returnDateUnix(date, format='YYYY-MM-DD HH:mm') {
            if(!date) {
                return '';
            }
            return momentTimezone.unix(date).tz('Asia/Seoul').locale('ko').format(format)
        }
    },
}
